import React, {FC, ReactNode, useRef} from 'react';

import {
  MessageViewerEducationTip,
  messageViewerEducationTipMessageIndexes,
} from './messageViewerEducationTip';

/*
 * Props.
 */

interface MessageViewerEducationTipCoordinatorProps {
  /** The conversation ID of the message being wrapped. */
  conversationId: number;
  /** The activity ID of the message being wrapped. */
  activityId: number;
  /** The activity IDs of the messages at the top of the conversation, or `undefined` if we're not at the top. */
  firstMessageActivityIds: ReadonlyArray<number> | undefined;
  children: ReactNode;
}

/*
 * Component.
 */

export const MessageViewerEducationTipCoordinator: FC<MessageViewerEducationTipCoordinatorProps> = (
  props,
) => {
  // Render the wrapper unconditionally, to avoid issues that affect only new signups.
  const messageElementRef = useRef<HTMLDivElement>(null);

  // Render the education tip components only if we're on a message that's eligible for one.
  const eligibleMessageIndex = messageViewerEducationTipMessageIndexes.find(
    (messageIndex) => props.activityId === props.firstMessageActivityIds?.[messageIndex],
  );

  return (
    <>
      <div ref={messageElementRef}>{props.children}</div>

      {eligibleMessageIndex !== undefined && (
        <MessageViewerEducationTip
          messageElementRef={messageElementRef}
          conversationId={props.conversationId}
          messageIndex={eligibleMessageIndex}
        />
      )}
    </>
  );
};
